import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0.4;
  }

  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0.4;
  }
`;

export const StyledImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;

  img {
    width: 100%;
    max-height: 480px;
  }
`;

export const StyledSoundPlayer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;

  audio {
    min-width: 100%;
    max-height: 40px;
    flex-grow: 1;
  }
`;

export const StyledMarkerArea = styled.div<{ end: number; start: number }>`
  position: absolute;
  bottom: 0;
  width: ${({ start, end }) => `calc(${end}% - ${start}%)`};
  height: 100%;
  left: ${({ start }) => `${start}%`};
  z-index: 1;

  input {
    margin: 0;
    padding: 0;
    height: 100%;
    min-width: calc(100% + 16px);
    border: none;
    opacity: 0;
    position: absolute;
    z-index: 5;
    cursor: pointer;
  }
`;
export const StyledMarker = styled.mark<{ isPlaying: boolean }>`
  position: absolute;
  bottom: 0;
  height: 100%;
  background-color: var(--color-interaction-link);
  width: 16px;
  animation-timing-function: linear;
  animation-duration: 0.5s;
  animation-name: ${(props) => (props.isPlaying ? fadeIn : fadeOut)};
  animation-fill-mode: forwards;
`;
